import React from 'react';
import { Container } from 'components/UI';
import { Title } from '@landing/ui';
import ProgramItems from './ProgramItems';
import { getMeetupDateString } from 'utils';
import { meetupStartTime, timeZone } from 'define';

import * as styles from './EventProgram.module.scss';

export default function EventProgram({ title, items }) {
  const dateAndMonth = getMeetupDateString({ day: '2-digit', month: 'long' });
  const subtitle = `Friday, ${dateAndMonth}, ${meetupStartTime} ${timeZone}`;

  return (
    <Container id="program" className={styles.container} background="transparent">
      <div className={styles.layout}>
        <Title color="white">{title}</Title>
        <p className={styles.subtitle}>{subtitle}</p>
        <div className={styles.itemsWrapper}>
          <ProgramItems items={items} />
        </div>
      </div>
    </Container>
  );
}
